import type { AnchorHTMLAttributes, ElementType } from 'react'
import styles from './Link.module.css'

export type LinkVariant = 'primary' | 'muted' | 'inherit'

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  variant?: LinkVariant
  external?: boolean
  as?: ElementType
  to?: string
  [key: string]: unknown
}

export function Link({
  variant = 'primary',
  external,
  className,
  as: Component = 'a',
  ...props
}: LinkProps) {
  const classes = [
    styles.link,
    styles[variant],
    className,
  ].filter(Boolean).join(' ')

  return (
    <Component
      className={classes}
      {...(external && { target: '_blank', rel: 'noopener noreferrer' })}
      {...props}
    />
  )
}
